// src/components/DealsSlider.jsx
import React from 'react'
import { Link } from 'react-router-dom'

export default function DealsSlider({ slides = [] }) {
  if (!slides.length) return null

  return (
    <section className="mb-4">
      <div className="container-xxl">
        <div
          id="dealsSlider"
          className="carousel slide deals-slider-wrapper"
          data-bs-ride="carousel"
          data-bs-interval="7000"
          data-bs-touch="true"
        >
          {/* Indicateurs */}
          <div className="carousel-indicators deals-indicators">
            {slides.map((s, idx) => (
              <button
                key={s.id || idx}
                type="button"
                data-bs-target="#dealsSlider"
                data-bs-slide-to={idx}
                className={idx === 0 ? 'active' : ''}
                aria-current={idx === 0 ? 'true' : undefined}
                aria-label={`Slide ${idx + 1}`}
              />
            ))}
          </div>

          {/* Slides */}
          <div className="carousel-inner">
            {slides.map((s, idx) => {
              const isFirst = idx === 0
              return (
                <div
                  key={s.id || idx}
                  className={`carousel-item ${isFirst ? 'active' : ''}`}
                >
                  <div
                    className="deals-slide d-flex align-items-center"
                    style={{ background: s.bgColor || '#002b7f' }}
                  >
                    <div className="row g-3 align-items-center w-100">
                      {/* Col gauche : image produit 1 */}
                      <div className="col-12 col-md-4">
                        <div className="deals-img-box">
                          {s.leftImg && (
                            <img
                              src={s.leftImg}
                              alt={s.leftAlt || 'Produit'}
                              loading="lazy"
                            />
                          )}
                        </div>
                      </div>

                      {/* Col centre : texte / CTA */}
                      <div className="col-12 col-md-4 text-center text-white">
                        {s.kicker && (
                          <div className="deals-kicker mb-1">
                            {s.kicker}
                          </div>
                        )}
                        {s.badge && (
                          <div className="deals-badge mb-2">
                            {s.badge}
                          </div>
                        )}
                        {s.title && (
                          <h2 className="deals-title mb-1">
                            {s.title}
                          </h2>
                        )}
                        {s.subtitle && (
                          <p className="deals-subtitle mb-3">
                            {s.subtitle}
                          </p>
                        )}

                        {s.ctaLabel && (
                          <Link
                            to={s.ctaHref || '/catalog'}
                            className="btn btn-light btn-sm deals-cta-btn"
                          >
                            {s.ctaLabel}
                          </Link>
                        )}
                      </div>

                      {/* Col droite : image produit 2 */}
                      <div className="col-12 col-md-4">
                        <div className="deals-img-box">
                          {s.rightImg && (
                            <img
                              src={s.rightImg}
                              alt={s.rightAlt || 'Produit'}
                              loading="lazy"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>

          {/* Flèches */}
          <button
            className="carousel-control-prev deals-control"
            type="button"
            data-bs-target="#dealsSlider"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="visually-hidden">Précédent</span>
          </button>
          <button
            className="carousel-control-next deals-control"
            type="button"
            data-bs-target="#dealsSlider"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="visually-hidden">Suivant</span>
          </button>
        </div>
      </div>
    </section>
  )
}
